import { Pipe, PipeTransform } from "@angular/core";
import {
  ReportDesignItemConfig,
  ReportDesignItemSignature
} from "../../report-design-item";

@Pipe({
  name: "asSignatureConfig",
  standalone: false
})
export class ReportItemConfigAsSignaturePipe implements PipeTransform {
  transform(value: ReportDesignItemConfig): ReportDesignItemSignature {
    return <ReportDesignItemSignature>value;
  }
}
